import ReportCreationProjects, { loader as reportCreationProjectsLoader } from "./report-creation-projects";
import ReportUsageProjects, { loader as reportUsageProjectsLoader } from "./report-usage-projects";
import ReportCreationAreas, { loader as reportCreationAreasLoader } from "./report-creation-areas";
import ReportUsageAreas, { loader as reportUsageAreasLoader } from "./report-usage-areas";
import { RootStore } from "../../../stores/root-store";
import { AppState } from "../../../stores/app-mobx";

type Report = {
    title: string;
    key: string;
    component: () => JSX.Element;
    loader: (rootStore: RootStore, appStore: AppState) => Promise<any>;
}

export const reportRegistry: Report[] = [
    {
        title: "Gesamtübersicht Beanspruchungs-Projekte",
        key: "report-beanspruchungs-projekte",
        component: ReportUsageProjects,
        loader: reportUsageProjectsLoader
    },
    {
        title: "Gesamtübersicht Neuschaffungs-Projekte",
        key: "report-neuschaffungs-projekte",
        component: ReportCreationProjects,
        loader: reportCreationProjectsLoader
    },
    {
        title: "Gesamtübersicht Beanspruchungs-Flächen",
        key: "report-beanspruchungs-flaechen",
        component: ReportUsageAreas,
        loader: reportUsageAreasLoader
    },
    {
        title: "Gesamtübersicht Neuschaffungs-Flächen",
        key: "report-neuschaffungs-flaechen",
        component: ReportCreationAreas,
        loader: reportCreationAreasLoader
    }
]

